import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class TipoEventoService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'tipo-evento');
  }

  listar(): Observable<any> {
    return this.index();
  }
}
